// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://dev.auth.api.fibre.services/api',
  reseau: 'losange',
  brandName: 'Losange',
  siteUrl: 'https://www.losange-fibre.fr',
  vdrUrl: 'https://viedureseau.losange-fibre.fr',
  gtagId: 'G-4996ZGYZ0Q',
  logo: '/assets/logo_losange2024.svg',
  logoFond: '/assets/logo_losange2024_FOND.jpg',
  favicon: 'assets/icon/favicon.png',
  project_id: 4,
  pageInformationId: 4,
  logGF: 'ck_33c2a85789852f268bbbfaef56c17326c7ab7d00',
  passGF: 'cs_b15b3a955136715467679a09ddc994c37a58805f',
  tinyMceKey: 'tsykhqqr6dn99vcf6bwz10y103pgzhiod0cygfqaasz0hrz1',
  pageDocumentationId: 6,
  // Questionnaire FUTÉ (Losange uniquement) — 0 = désactivé (Rosace)
  pageFormJsonId: 7,
  pageDocumentationCuivreId: 9,
  pageVideoId: 11,
  // Page "En savoir plus GFU"
  gfuInfoUrl: 'https://www.losange-fibre.fr/nos-reseaux-securises-gfu/',
  // Carte "contact" de l'espace GFU : true = page interne contacts, false = gfuContactUrl
  gfuContactPage: false,
  gfuContactUrl: 'https://www.losange-fibre.fr/mon-contact-collectivite/',
  // Palette de marque (injectée sur :root au bootstrap — variables.scss = défaut)
  palette: {
    blue: '#29659f',
    blueRgb: '41, 101, 159',
    blueHover: '#1f4a7d',
    blue2: '#00294f',
    homeTitle: '#00294f',
    gfusBannerBg: '#255a95',
    homeIconBg: '#00294f',
    contactItemBg: '#0068a4',
    globalBoxBg: '#0b3071',
    globalBoxHover: '#0f3b88',
    fileUploadBtnBg: '#3a71a6',
    fileUploadBtnHover: '#29659f',
    sectionTitle: '#036',
    btnDisabledBg: '#7294b5',
  },
  // Firebase Configuration
  firebase: {
    apiKey: "AIzaSyDKZz8OkC7TsNlGfmkPEpNrMwsFPWPVO4A",
    authDomain: "grand-est-losange.firebaseapp.com",
    projectId: "grand-est-losange",
    storageBucket: "grand-est-losange.firebasestorage.app",
    messagingSenderId: "344347857660",
    appId: "1:344347857660:web:d3e30821213929f4977d79",
    measurementId: "G-4996ZGYZ0Q"
  },

  enableAnalytics: true,
  debugAnalytics: true  // Activer le mode debug en développement
};
